import { render } from "./CommitteeForm.vue?vue&type=template&id=13fa0a8e&scoped=true&ts=true"
import script from "./CommitteeForm.ts?vue&type=script&lang=ts"
export * from "./CommitteeForm.ts?vue&type=script&lang=ts"

import "./CommitteeForm.scss?vue&type=style&index=0&id=13fa0a8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fa0a8e"]])

export default __exports__